import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const TravelCRM = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />
			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/travel-crm.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					Travel CRM
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					Travel CRM
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					Travel CRM Development
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={12}>
							<p>
								In this modern time whereby taking the help of Travel CRM, the
								Travel Industry is on the peak of the businesses which
								contributes to the boost for the economy of the world’s GDP. It
								is also stated in the report that the Travel and Tourism
								industry generated a huge percentage of all worldwide economic
								activity. In the Travel and Tourism Business, there are various
								modules like the B2C Booking System, B2B Booking System that you
								have to manage. Travel technology makes it easy by providing
								Travel CRM or Travel Portal Software. Now you can manage your
								B2B as well B2C Online travel Portal by using musafir’s Travel
								CRM.
							</p>
							<br />
							<p>
								Travel CRM i.e. Customer Relationship Management, is a software
								that helps travel companies including travel agents, Tour
								Operators, destination management companies (DMC) etc. to
								encourage strong customer relationships and improve sales and
								revenue by having quality communications with anticipations and
								customers.
							</p>
							<br />
							<p>
								Arya Aviation Travel CRM provides complete travel agency
								management software under one roof consisting of B2B, B2C,
								Agent, Customer, Finance, Staff, Sales, Reports, Marketing
								management etc. Travel CRM or Online Travel Agency Software not
								only manages current running tasks but also provides a real-time
								update for upcoming events. Arya Aviation's Cloud-Based System
								increases its accessibility.
							</p>
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default TravelCRM;
